export const apiGetRectangle = (map, options, mapID) => {
  // eslint-disable-next-line
  const self = REINOS_MAPS

  const rectangle = self.searchRectangle(mapID, options.key)

  //is there a map
  if (map && rectangle !== undefined) {
    return rectangle
  }
}
